"use client";

import { useState, useEffect } from "react";
import Image from "next/image";

export default function Testimonials() {
  const testimonials = [
    {
      text: "I was skeptical about a free workshop, but this completely blew me away. I learned more in 3 hours than I did from months of YouTube tutorials. Already using these tools daily at work.",
      name: "Michael T.",
    },
    {
      text: "I'm not a tech person at all, but this workshop made everything click. Now I use AI for emails, content, and even presentations. Life-changing stuff.",
      name: "Jonathan P.",
    },
    {
      text: "I've attended a lot of online workshops, but this one actually delivered. Practical, no fluff, and I left with tools I could use the very next day. Worth every minute.",
      name: "James R.",
    },
    {
      text: "I've been wanting to learn AI for months, but didn't know where to start. This workshop gave me the perfect foundation. Simple, clear, and incredibly useful.",
      name: "Priya S.",
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  // Auto-slider: move to next slide every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [testimonials.length]);

  return (
    <section className="w-full py-10 md:py-16">
      <div
        className="w-full md:w-[80%] mx-auto relative p-4 md:px-0 bg-[#FFFAF1] rounded-xl"
      >
        {/* Top Left Quotation Mark Image */}
        <div className="absolute top-0 left-0 z-10">
          <Image
            src="/images/ctl.svg"
            alt="Opening quote"
            width={120}
            height={120}
            className="w-[60px] h-[60px] md:w-[120px] md:h-[120px]"
            unoptimized
          />
        </div>

        {/* Bottom Right Quotation Mark Image */}
        <div className="absolute bottom-0 right-0 z-10">
          <Image
            src="/images/cbr.svg"
            alt="Closing quote"
            width={120}
            height={120}
            className="w-[60px] h-[60px] md:w-[120px] md:h-[120px]"
            unoptimized
          />
        </div>

        {/* Testimonial Card Container */}
        <div className="w-full md:w-[80%] mx-auto relative">
          {/* Testimonial Card */}
          <div
            className="rounded-xl p-6 md:p-10 relative mx-auto overflow-hidden"
            style={{
              backgroundColor: "#FFFAF1",
            }}
          >
            {/* Mobile: Text container 80% width */}
            <div className="w-[80%] md:w-full mx-auto text-center relative overflow-hidden">
              {/* Slide Animation Container */}
              <div
                className="flex transition-transform duration-500 ease-in-out"
                style={{
                  transform: `translateX(-${currentIndex * 100}%)`,
                }}
              >
                {testimonials.map((testimonial, index) => (
                  <div
                    key={index}
                    className="w-full flex-shrink-0"
                    style={{ minWidth: "100%" }}
                  >
                    {/* Testimonial Text */}
                    <p className="text-[#041B01] text-lg md:text-xl font-normal leading-relaxed mb-6 relative z-10">
                      {testimonial.text}
                    </p>

                    {/* Name */}
                    <p className="text-[#041B01] text-base md:text-lg font-medium relative z-10">
                      {testimonial.name}
                    </p>
                  </div>
                ))}
              </div>
            </div>

            {/* Pagination Dots */}
            <div className="flex justify-center gap-2 mt-8 relative z-10">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  onClick={() => goToSlide(index)}
                  className={`w-2 h-2 rounded-full transition-all ${
                    index === currentIndex
                      ? "bg-[#041B01]"
                      : "bg-[#041B01] opacity-30"
                  }`}
                  aria-label={`Go to testimonial ${index + 1}`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
